import { render } from "./TradeInList.vue?vue&type=template&id=7b4dc574"
import script from "./TradeInList.vue?vue&type=script&lang=js"
export * from "./TradeInList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__